import { FC, PropsWithChildren, useMemo } from 'react';

import { Toolbar } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { useSidebarContext } from 'shared/providers/Sidebar';
import { ROUTES } from 'shared/constants';
import { useAccessibleAccounts } from 'shared/providers/AccessibleAccounts';
import { useAuth } from 'shared/providers/Auth';

import { StyledMain } from './Main.styled';
import { Wrapper } from './Wrapper.styled';

const pagesWithoutFixedWidth = [ROUTES.INVOICES, ROUTES.RE_ENROLMENT, ROUTES.RE_ENROLMENT_CONTRACT];

export const Main: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();

  const { isOpen } = useSidebarContext();
  const { isCurrentAccountObserver } = useAccessibleAccounts();
  const { actAsUser } = useAuth();

  // TODO: refactor this to have common layout
  const fixedWidth = useMemo(
    () => !pagesWithoutFixedWidth.includes(location.pathname.split('/').pop() || ''),
    [location.pathname]
  );

  return (
    <StyledMain isSidebarOpen={isOpen}>
      <Wrapper fixedWidth={fixedWidth} extraMarginBottom={isCurrentAccountObserver || !!actAsUser}>
        <Toolbar />
        {children}
      </Wrapper>
    </StyledMain>
  );
};
